<div class="dialog-container">
  <h2 matDialogTitle class="visually-hidden">
    {{ "Msg-Confirm-Delete-Title" | translate }}
  </h2>
  <div class="header-wrapper">
    <span class="dark font-bold font-20">
      {{ "Actions-List.Delete" | translate }}
    </span>
    <div class="icon-wrapper" matDialogClose>
      <i class="bi bi-x-lg"></i>
    </div>
  </div>
  <div class="content-wrapper">
    <span class="font-bold dark font-18">
      {{ "Msg-Confirm-Delete-Title" | translate }}
    </span>
    <span class="mt-2 light font-14">
      {{ "Msg-Confirm-Delete-Msg" | translate }}
    </span>
  </div>
  <div class="footer-wrapper">
    <button class="default" matDialogClose>
      {{ "Actions-List.Close" | translate }}
    </button>
    <button class="danger" matDialogClose (click)="confirm()">
      {{ "Actions-List.Yes" | translate }}
    </button>
  </div>
</div>
